// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__mlVA8","warning":"style_warning__HNgvv","text":"style_text__NNKXG"};